(function () {
  /* Hero slider: scroll-snap + dots + autoplay */
  function initHero(root) {
    if (root.dataset.nrInit) return; root.dataset.nrInit = '1';
    var track = root.querySelector('.nr-hero__track');
    var slides = root.querySelectorAll('.nr-hero__slide');
    var dotsWrap = root.querySelector('.nr-hero__dots');
    if (!track || slides.length < 2) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }
    var dots = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'nr-hero__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(b); dots.push(b);
    });
    function idx() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function go(i) { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () {
      var c = idx(); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
    }, { passive: true });
    var speed = parseInt(root.dataset.speed || '5', 10) * 1000, timer = null;
    function restart() {
      if (timer) clearInterval(timer);
      if (root.dataset.autoplay !== 'true') return;
      timer = setInterval(function () { go((idx() + 1) % slides.length); }, speed);
    }
    track.addEventListener('pointerdown', restart);
    restart();
  }

  /* Tabs */
  function initTabs(root) {
    if (root.dataset.nrInit) return; root.dataset.nrInit = '1';
    var tabs = root.querySelectorAll('.nr-tab');
    var panels = root.querySelectorAll('.nr-panel');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.classList.toggle('is-active', j === i); x.setAttribute('aria-selected', j === i); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
      });
    });
  }

  /* Sticky add to cart on product page */
  function initSticky() {
    var bar = document.querySelector('.nr-sticky');
    if (!bar || bar.dataset.nrInit) return; bar.dataset.nrInit = '1';
    var main = document.querySelector('#MainContent .main-product') || document.querySelector('.main-product');
    if (!main) return;
    function mainBtn() {
      return main.querySelector('form[action*="/cart/add"] [type="submit"][name="add"], form[action*="/cart/add"] button[type="submit"], .product-form__submit');
    }
    var target = mainBtn() || main;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past);
        });
      }).observe(target);
    }
    var btn = bar.querySelector('[data-nr-sticky-add]');
    if (btn) btn.addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) { b.click(); }
      else { main.scrollIntoView({ behavior: 'smooth' }); }
    });
    /* Keep variant label/price in sync */
    setInterval(function () {
      var priceEl = main.querySelector('.price_block .price, .price-item--regular, .price');
      var meta = bar.querySelector('[data-nr-sticky-price]');
      if (priceEl && meta && priceEl.textContent.trim()) meta.textContent = priceEl.textContent.trim().replace(/\s+/g, ' ');
    }, 800);
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.nr-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() {
    document.querySelectorAll('.nr-hero').forEach(initHero);
    document.querySelectorAll('[data-nr-tabs]').forEach(initTabs);
    initSticky();
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
